// import firebase from 'firebase/compat/app'
// import 'firebase/compat/auth'
import {initializeApp} from 'firebase/app'
import {getFirestore } from 'firebase/firestore'
import  {getAuth} from 'firebase/auth'

const firebaseApp = initializeApp({
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_URL,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
});

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);
export { auth,db};
export default firebaseApp